import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import logoHeader from "../../assets/logo.png";
// Formulario legacy: ModalContacto / Formulario (sin uso en CTAs; recuperable)
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { buildRouteWithUtms } from "../../config/whatsappConfig";
import useFinanciaciones from "../../config/useFinanciaciones";
import { dismissLcpHeaderShell } from "../../config/firestoreRest";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
  { label: "Plan de ahorro", sectionId: "plan", route: "/plan" },
];

const Header = () => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();
  const location = useLocation();
  const history = useHistory();
  const { tipo } = useParams();

  const navItems = NAV_ITEMS.filter(
    (item) =>
      item.sectionId !== "financiaciones" || (!loadingFinanciaciones && financiaciones.length > 0)
  );

  useEffect(() => {
    dismissLcpHeaderShell();
  }, []);

  const handlePedirPresupuesto = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });
    openConsultaForm();
  };

  const handleNavClick = ({ sectionId, route }) => {
    const search = location.search;
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route, search));
    }

    setTimeout(() => {
      scroller.scrollTo(sectionId, { smooth: true, duration: 500, offset: -10 });
    }, currentTipo !== targetTipo ? 350 : 0);
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header">
          <Col lg={3} md={4} xs={12} className="text-sm-start text-center py-2">
            <Link to={buildRouteWithUtms("/todos", location.search)}>
              <img
                src={logoHeader}
                alt="Montironi Jeep"
                className="header-logo"
                width={160}
                height={36}
                decoding="async"
                fetchPriority="low"
              />
            </Link>
          </Col>
          <Col
            lg={9}
            md={8}
            xs={12}
            className="text-sm-start text-center py-2 justify-content-md-end justify-content-center d-md-flex d-none"
          >
            <nav className="header-nav" aria-label="Navegación principal">
              {navItems.map((item) => (
                <button
                  key={item.sectionId}
                  type="button"
                  className="link-header border-0 bg-transparent"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}

              <Button className="btn-jeep-corporate ms-md-2" onClick={handlePedirPresupuesto}>
                Solicitar cotización
              </Button>
            </nav>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;
